/**
 * LegalActionRequest permissions — distinct from FRP / credit_review advisory.
 */

export const LEGAL_ACTION_READ_PERMISSION = 'legal_action:read' as const;
export const LEGAL_ACTION_CREATE_PERMISSION = 'legal_action:create' as const;
export const LEGAL_ACTION_SUBMIT_PERMISSION = 'legal_action:submit' as const;
export const LEGAL_ACTION_APPROVE_PERMISSION = 'legal_action:approve' as const;
export const LEGAL_ACTION_CLOSE_PERMISSION = 'legal_action:close' as const;

export const LEGAL_ACTION_PERMISSIONS = [
  LEGAL_ACTION_READ_PERMISSION,
  LEGAL_ACTION_CREATE_PERMISSION,
  LEGAL_ACTION_SUBMIT_PERMISSION,
  LEGAL_ACTION_APPROVE_PERMISSION,
  LEGAL_ACTION_CLOSE_PERMISSION,
] as const;

export type LegalActionPermission = (typeof LEGAL_ACTION_PERMISSIONS)[number];

export function isLegalActionPermission(permission: string): permission is LegalActionPermission {
  return (LEGAL_ACTION_PERMISSIONS as readonly string[]).includes(permission);
}
